import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, TaxArea } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-tax-areas-list',
  templateUrl: './epbt-fa-tax-areas-list.component.html',
  styleUrls: ['./epbt-fa-tax-areas-list.component.scss']
})
export class EpbtFaTaxAreasListComponent implements OnInit {

  private _selectedTaxArea: number;
  @Input('selectedTaxArea') set selectedTaxArea(value: number) {
    this._selectedTaxArea = value;

    if (this._selectedTaxArea) {
      var result = this.taxAreas.filter(x => x.taxAreaID == this._selectedTaxArea);
      this.bisTrackTaxAreaChange.emit(result ? result[0] : null);
    }
  }
  get selectedTaxArea(): number {
    return this._selectedTaxArea;
  }

  taxAreas: any[] = [];

  @Output() bisTrackTaxAreaChange = new EventEmitter<any>();

  @Input() labelText: string = "";

  constructor(private client: FieldAgentClient) { }

  ngOnInit() {
    this.getTaxAreas();
  }

  getTaxAreas() {
    this.client.getTaxAreas().subscribe(res => {
      this.taxAreas = res;
      let defaultTaxArea = new TaxArea();
      defaultTaxArea.taxAreaID = -1;
      defaultTaxArea.name = "(Select a tax area)";
      this.taxAreas.unshift(defaultTaxArea);
    });
  }
}
